export enum FacilityFormStepEnum {
  AVAILABILITY = 'facilityAvailabilityStep',
  GUESTS = 'guestDetailsStep',
  CUSTOMISE = 'customisFacilityStep',
}
